// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
// MODULES
import {
  REMIND_CLIENT_OF_UPCOMING_INVOICE,
  REMIND_CLIENT_OF_SESSION,
  REMIND_CLIENT_OF_LATE_INVOICE,
} from 'lib/constants/cron-job-types';
// COMPONENTS
import TwilioConnect from './TwilioConnect';
import Switches from './Switches';
import SectionHeader from 'components/text/SectionHeader';
import ReminderSettingItem from './ReminderSettingItem';

const AlertSection = ({ children, title }) => (
  <div style={{ maxWidth: '100%', width: 550, marginTop: 25 }}>
    <SectionHeader>{title}</SectionHeader>
    <div style={{ backgroundColor: 'white', padding: 10, borderRadius: 5 }}>{children}</div>
  </div>
);

class AlertsArea extends React.PureComponent {
  render() {
    const { currentUser } = this.props;
    const { nedNotificationsSettings } = currentUser.organization;

    return (
      <div style={{ maxWidth: '100%' }} className="p1">
        <AlertSection title="HeyNed Text/SMS Alerts">
          <b>Phone Number:</b>
          <TwilioConnect user={currentUser} />
          <b>Alert Me By Text/SMS When...</b>
          <Switches user={currentUser} />
        </AlertSection>
        <AlertSection title="Reminder Emails">
          <ReminderSettingItem
            label="Send a Session Reminder"
            type={REMIND_CLIENT_OF_SESSION}
            email={
              nedNotificationsSettings
              && nedNotificationsSettings[REMIND_CLIENT_OF_SESSION]
              && nedNotificationsSettings[REMIND_CLIENT_OF_SESSION].email
            }
            days={
              nedNotificationsSettings
              && nedNotificationsSettings[REMIND_CLIENT_OF_SESSION]
              && nedNotificationsSettings[REMIND_CLIENT_OF_SESSION].days
            }
            tooltip={
              "Setup a friendly email reminder that Ned will send out automatically for any sessions with clients. Every day at 11am EST Ned checks for reminders he shoudl send out. If he finds it's time to send out your reminder, he'll issue an email to your client reminding them."
            }
          />
          <ReminderSettingItem
            label="Send a Invoice Reminder"
            type={REMIND_CLIENT_OF_UPCOMING_INVOICE}
            email={
              nedNotificationsSettings
              && nedNotificationsSettings[REMIND_CLIENT_OF_UPCOMING_INVOICE]
              && nedNotificationsSettings[REMIND_CLIENT_OF_UPCOMING_INVOICE].email
            }
            days={
              nedNotificationsSettings
              && nedNotificationsSettings[REMIND_CLIENT_OF_UPCOMING_INVOICE]
              && nedNotificationsSettings[REMIND_CLIENT_OF_UPCOMING_INVOICE].days
            }
            tooltip={
              "Setup a friendly email reminder that Ned will send out automatically for any sessions with clients. Every day at 11am EST Ned checks for reminders he shoudl send out. If he finds it's time to send out your reminder, he'll issue an email to your client reminding them."
            }
          />
          <ReminderSettingItem
            label="Send a Late Invoice Reminder"
            type={REMIND_CLIENT_OF_LATE_INVOICE}
            email={
              nedNotificationsSettings
              && nedNotificationsSettings[REMIND_CLIENT_OF_LATE_INVOICE]
              && nedNotificationsSettings[REMIND_CLIENT_OF_LATE_INVOICE].email
            }
            days={
              nedNotificationsSettings
              && nedNotificationsSettings[REMIND_CLIENT_OF_LATE_INVOICE]
              && nedNotificationsSettings[REMIND_CLIENT_OF_LATE_INVOICE].days
            }
            tooltip={
              "Setup a friendly email reminder that Ned will send out automatically for any sessions with clients. Every day at 11am EST Ned checks for reminders he shoudl send out. If he finds it's time to send out your reminder, he'll issue an email to your client reminding them."
            }
          />
        </AlertSection>
      </div>
    );
  }
}

// SMSNotifications.propTypes = {
//   userData: PropTypes.shape({
//     error: PropTypes.object,
//     loading: PropTypes.bool.isRequired,
//     user: PropTypes.object,
//   }).isRequired,
// };

// const withData = graphql(GET_USER_DATA, { name: 'userData' });

export default AlertsArea;



// WEBPACK FOOTER //
// ./src/routes/app-studio/AlertsArea/index.js